/**
* BaseDirective
**/
require("../directives/modal");
require("../directives/eatClick");
require("../directives/person");
require("../directives/strgEnter");
require("../directives/onfocus");
require("../directives/comment");
require("../directives/post");
require("../directives/scroll");
require("../directives/file");
require("../directives/stopEvent");
require("../directives/syntaxify");
require("../directives/autofocus");
require("../directives/scrollToID");
require("../directives/savebutton");
require("../directives/focusMe");
require("../directives/advancedsend");
require("../directives/userimage");
require("../directives/accessibleClick");
require("../directives/qrScanner");
require("../directives/validatedForm");
require("../directives/passwordinput");
require("../directives/gallery");
require("../directives/smartDate");
require("../directives/createcircle");
require("../directives/search");
require("../directives/lazyiframe");
require("../directives/mobile");
require("../directives/whispeerSref");
require("../directives/loader");
require("../directives/inputGrowDirective");
require("../directives/newPost");
require("../directives/inviteButtons");
require("../directives/closeSidebar");
require("../directives/loadingindicator");
require("../directives/displayFile");
require("../directives/loadingProgress");
require("../directives/voicemailPlayer");
require("../directives/burstDifference");



// WEBPACK FOOTER //
// ./js/directives/directives.js